import { WorkRuleSetRule } from "@rhumbix/rmbx_work_rules"
import { AllExceptions, AnyException, TkSummary } from "../common/types"

interface iToggleException {
    type: "TOGGLE_EXCEPTION"
    whichException: keyof AllExceptions
}

interface iSetExceptionValue {
    type: "SET_EXCEPTION_VALUE"
    exception: AnyException
}

interface iSetTkSummary {
    type: "SET_TK_SUMMARY"
    data: any
}

interface iSetWorkRuleOverride {
    type: "SET_WORK_RULE_OVERRIDE"
    data: WorkRuleSetRule[]
}

interface iClearWorkRuleOverride {
    type: "CLEAR_WORK_RULE_OVERRIDE"
}

interface iFilterExceptions {
    type: "TOGGLE_FILTER_EXCEPTIONS"
}

export const setExceptionValue = (exception: AnyException): iSetExceptionValue => {
    return {
        type: "SET_EXCEPTION_VALUE",
        exception,
    }
}

export const toggleException = (whichException: keyof AllExceptions): iToggleException => {
    return {
        type: "TOGGLE_EXCEPTION",
        whichException,
    }
}

export const toggleFilterExceptions = (): iFilterExceptions => {
    return {
        type: "TOGGLE_FILTER_EXCEPTIONS",
    }
}

export const setTkSummary = (tkSummary: TkSummary): iSetTkSummary => {
    return {
        type: "SET_TK_SUMMARY",
        data: tkSummary,
    }
}

export const setWorkRuleOverride = (workRuleValues: WorkRuleSetRule[]): iSetWorkRuleOverride => {
    return {
        type: "SET_WORK_RULE_OVERRIDE",
        data: workRuleValues,
    }
}

export const clearWorkRuleOverride = (): iClearWorkRuleOverride => {
    return {
        type: "CLEAR_WORK_RULE_OVERRIDE",
    }
}

export type ExceptionAction = iToggleException | iSetExceptionValue | iFilterExceptions | iSetTkSummary | iSetWorkRuleOverride | iClearWorkRuleOverride
